import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import { initOutbrainApi } from './outbrain';
import TagManager from 'react-gtm-module';

let ReactPixel = null;

export const initOutbrain = () => {
  console.log('Outbrain init');
  initOutbrainApi(window, document);
};

export const initGA = (id, allowGooleAdsConversionTracking = false) => {
  if (!id) throw 'Could not initialize GA: No GA id provided';
  const GA_TESTMODE = process.env.REACT_GA_TESTMODE === 'true';
  const gaOptions = {
    anonymizeIp: true,
    storeGac: allowGooleAdsConversionTracking,
  };
  console.log('GA init', { testMode: GA_TESTMODE, gaOptions });
  ReactGA.initialize(id, { testMode: GA_TESTMODE, gaOptions });
  ReactGA.set({ anonymizeIp: true });
  ReactGA.set({ storeGac: allowGooleAdsConversionTracking });
};

export const initGA4 = (id, allowGooleAdsConversionTracking = false) => {
  if (!id) throw 'Could not initialize GA: No GA id provided';
  const GA_TESTMODE = process.env.REACT_GA_TESTMODE === 'true';
  const gaOptions = {
    anonymizeIp: true,
    storeGac: allowGooleAdsConversionTracking,
  };
  console.log('GA4 init', { testMode: GA_TESTMODE, gaOptions });
  ReactGA4.initialize(id, { testMode: GA_TESTMODE, gaOptions });
  // GA4 IP anonymization is always enabled for GA4 properties & no manual action is required.
  // https://codechilli.lk/ip-anonymization-ip-masking-in-google-analytics-universal-analytics-ga4/
  // ReactGA4.set({ anonymizeIp: true });
  // ReactGA4.set({ storeGac: allowGooleAdsConversionTracking });
};
export const initFP = id => {
  if (!id)
    throw 'Could not initialize FacebookPixel: No Facebook Pixel id provided';
  const GA_TESTMODE = process.env.REACT_GA_TESTMODE === 'true';
  console.log('FacebookPixel init', { debug: GA_TESTMODE });
  ReactPixel = require('react-facebook-pixel').default;
  ReactPixel.init(
    id,
    {},
    {
      autoConfig: true,
      debug: GA_TESTMODE,
    },
  );
};

const filteredPaths = ['reset', 'signup', 'forgot-password'];

const isFilteredPath = () => {
  if (filteredPaths.some(p => window.location.pathname.includes(p))) {
    console.log(`GA: Not logging filteredPaths`);
    return true;
  }
  return false;
};

export const logPageViewOb = () => {
  if (isFilteredPath()) return;
  // requested by client that outbrain only tracks on besser mit pellets
  if (window.location.host !== 'besser-mit-pellets.de') return;
  console.log(`OB: Logging pageview outbrain`);
  window.obApi('track', 'PAGE_VIEW');
};
export const logPageViewGA = () => {
  if (isFilteredPath()) return;
  const page = window.location.pathname + window.location.search;
  console.log(`GA: Logging pageview for ${page}`);
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

export const logPageViewGA4 = () => {
  if (isFilteredPath()) return;
  const page = window.location.pathname + window.location.search;
  console.log(`GA4: Logging pageview for ${page}`);
  ReactGA4.set({ page });
  ReactGA4.send({ hitType: 'pageview', page });
};

export const logPageViewFP = () => {
  const page = window.location.pathname + window.location.search;
  if (isFilteredPath()) return;
  if (!ReactPixel) throw 'ReactPixel has not been initialised';
  console.log(`FP: Logging pageview for ${page}`);
  ReactPixel.pageView();
};

export const logEvent = ({ category = '', action = '', label = '' }) => {
  if (category && action) {
    ReactGA.event({ category, action, label });
  }
};

export const logEventGA4 = ({ category = '', action = '', label = '' }) => {
  if (category && action) {
    ReactGA4.event({ category, action, label });
  }
};

export const logException = (description = '', fatal = false) => {
  if (description) {
    ReactGA.exception({ description, fatal });
  }
};

const tagManagerArgs = {
  gtmId: 'GTM-WL39JL7',
};

export const initGTM = () => {
  const GA_TESTMODE = process.env.REACT_GA_TESTMODE === 'true';
  if (GA_TESTMODE) {
    console.log('GTM: Testmode activated, GTM not initialized');
    return;
  }
  TagManager.initialize(tagManagerArgs);
  console.log('GTM: initialized', tagManagerArgs.gtmId);
};
